/*
 *
 * PayByLinkFirstActivationPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  emailFormatError: <PortalMessage id='t.app.components.ModifyNumberModal.invalidEmailFormat' defaultMessage='Formato email non valido' />,
  formEmailLabel: <PortalMessage id='t.app.email' defaultMessage='Email' />,
  formPrefixLabel: <PortalMessage id='t.app.phoneNumber' defaultMessage='Numero di telefono' />,
  requiredError: <PortalMessage id='t.app.components.ModifyNumberModal.requiredField' defaultMessage='Il campo è obbligatorio' />,
  textAboveThePhones: <PortalMessage id='t.app.components.ModifyNumberModal.textAboveThePhones' defaultMessage='Utilizzeremo questi dati esclusivamente ai fini del servizio. Eventuali modifiche non comporteranno variazioni ai dati anagrafici nel tuo profilo.' />,
  invalidPhoneNumberFormat: <PortalMessage id='t.app.components.ModifyNumberModal.invalidPhoneNumberFormat' defaultMessage='Formato del numero di telefono non valido' />
}

export default formattedMessage
